import {FiInfo} from "react-icons/fi";

import {Icon} from "@/components/icon/Icon.tsx";

interface CheckFormInfoProps {
  title: string;
  className?: string;
  typographySize?: "small" | "normal";
}

export const CheckFormInfo = ({title, className, typographySize = "normal"}: CheckFormInfoProps) => (
  <div className={className}>
    <Icon icon={FiInfo} display="inline" />
    <span className={typographySize === "small" ? "pulseTextBodySmall" : "pulseTextBody"}>{title}</span>
  </div>
);
